import { cn } from '../../utils';
import { Fragment, ReactElement, ReactNode } from 'react';

type CardHeadingProps = {
    title?: string;
    subtitle?: string;
    actions?: ReactElement[];
    avatar?: ReactNode;
    border?: boolean;
};

export default function CardHeading({
    actions = [],
    avatar,
    title,
    subtitle,
    border = true,
}: CardHeadingProps) {
    return (
        <div
            data-testid="CardHeading"
            className={cn('alli-bg-white alli-px-4 alli-py-5 sm:alli-px-6', {
                'alli-border-b alli-border-gray-400': border,
            })}>
            <div className="-alli-mt-4 alli--ml-4 alli-flex alli-flex-wrap alli-items-center alli-justify-between sm:alli-flex-nowrap">
                <div className="alli-ml-4 alli-mt-4">
                    <div className="alli-flex alli-items-center">
                        {avatar && (
                            <div className="alli-flex-shrink-0">{avatar}</div>
                        )}
                        <div className="alli-ml-4">
                            {title && (
                                <h3 className="alli-text-base alli-font-medium alli-leading-6 alli-text-blue-gray-700">
                                    {title}
                                </h3>
                            )}
                            {subtitle && (
                                <p className="alli-text-sm alli-text-gray-700">
                                    {subtitle}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
                <div className="alli-ml-4 alli-mt-4 alli-flex alli-flex-shrink-0 alli-space-x-4">
                    {actions?.length > 0 &&
                        actions.map((b, index) => (
                            <Fragment key={`card-heading-button-${index}`}>
                                {b}
                            </Fragment>
                        ))}
                </div>
            </div>
        </div>
    );
}
